//@flow

import styled from "styled-components"
import * as BaseUI from "../UI"

export const TitleText = BaseUI.TitleText

export const TitleDescription = BaseUI.TitleDescription

export const ContentContainer = styled.div`
  height: 100%;
  width: 100%;
  top: 0;
  left: 0;
  position: absolute;
  background: #a5d9f2;
`

export const Titles = styled.div`
  position: absolute;
  top: 104px;
  right: 174px;
  width: 600px;
  z-index: 4;
`

export const Foreground = styled.div`
  position: absolute;
  bottom: -100px;
  left: 0px;
  height: 692px;
  width: 2133px;
  z-index: 2;
`

export const Midground = styled.div`
  position: absolute;
  bottom: 186px;
  left: 0px;
  height: 241px;
  width: 2285px;
  z-index: 1;
`

export const Background = styled.div`
  position: absolute;
  top: 0px;
  left: 0px;
  height: 571px;
  width: 2285px;
  z-index: 0;
`



// WEBPACK FOOTER //
// ./src/Kiosk/CommitView/Ride/UI.js